import { render, staticRenderFns } from "./CustomerPiutangList.vue?vue&type=template&id=a6e6dc38"
import script from "./CustomerPiutangList.vue?vue&type=script&lang=js"
export * from "./CustomerPiutangList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports